export default {
  common__validation__is_required: 'Bu sahə mütləq doldurulmalıdır',
  common__validation__invalid_format: 'Yanlış format',
  common__validation__invalid_file_size: 'Faylın ölçüsü maksimum limitdən ({size}) çoxdur',
};
